export const DISMISSED_BANNERS_LOCAL_STORAGE_KEY = "heroBanner.dismissed"

export const getDismissedBanners = (): string[] => {
  if (typeof window === "undefined") return []
  try {
    const raw = window.localStorage.getItem(DISMISSED_BANNERS_LOCAL_STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed)
      ? parsed.filter((v) => typeof v === "string")
      : []
  } catch {
    return []
  }
}

export const addDismissedBanner = (uid: string): string[] => {
  if (typeof window === "undefined") return []
  const current = getDismissedBanners()
  if (current.includes(uid)) return current
  const next = [...current, uid]
  try {
    window.localStorage.setItem(
      DISMISSED_BANNERS_LOCAL_STORAGE_KEY,
      JSON.stringify(next),
    )
  } catch {
    // ignore storage errors (quota / disabled)
  }
  return next
}

export const isBannerDismissed = (uid: string): boolean => {
  return getDismissedBanners().includes(uid)
}
